import { createCoderDocument } from '@/managers/documents/useCases/createCoderDocument';
import { removeCoderDocument } from '@/managers/documents/useCases/removeCoderDocument';

export default {
  createCoderDocument,
  removeCoderDocument,
};
